// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"177":"c3795228","417":"215efc47","500":"a0643dfb","818":"c02ea3cf"}[chunkId] + ".js";
};